import { createTheme } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import * as _ from 'lodash'

const eventTheme = (eventTheme: object | null) => {
      const theme = useTheme()
      if (!eventTheme) {
            return createTheme(theme)
      }
      let overrideTheme = {}
      if (!eventTheme) {
            console.warn(`No theme found for event ID ${eventId}. Using default theme.`)
      } else {
            overrideTheme = eventTheme
      }
      const merged = _.merge({}, theme, overrideTheme)
      return createTheme(merged)
}

export default eventTheme
